(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-text"] && !Shopify.designMode) return;
  try {
    
class KsAnimatedRichtext extends HTMLElement {
  constructor () {
    super()

    this.animateOnScroll()
  }

  animateOnScroll() {
    if (this.dataset.animateOnScroll === 'false') return

    const container = this.querySelector('.ks-animated-richtext-inner');
    const words = container.querySelectorAll('span');

    function updateWordVisibility() {
      const rect = container.getBoundingClientRect();
      const start = window.innerHeight * 0.1;
      const end = window.innerHeight * .4;
      const progress = Math.min(Math.max((window.innerHeight - rect.top - start) / (end - start), 0), 1);
      const wordCount = words.length;
      const visibleCount = Math.floor(progress * wordCount);

      words.forEach((word, index) => {
        if (index < visibleCount) {
          word.classList.add('visible');
        } else {
          word.classList.remove('visible');
        }
      });
    }

    document.addEventListener('scroll', updateWordVisibility, { passive: true });
    window.addEventListener('resize', updateWordVisibility);
    window.addEventListener('load', updateWordVisibility);
  }
}
customElements.define('ks-animated-richtext', KsAnimatedRichtext)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["big-why"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.ekb-bigwhy').forEach(function(root){
      var track = root.querySelector('[data-ekb-track]');
      var prev = root.querySelector('.ekb-bigwhy__arrow--prev');
      var next = root.querySelector('.ekb-bigwhy__arrow--next');
      if(!track) return;

      function scrollByCard(dir){
        var card = track.querySelector('.ekb-bigwhy__card');
        if(!card) return;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        var dist = card.getBoundingClientRect().width + gap;

        var isMobile = window.matchMedia('(max-width: 860px)').matches;
        if(isMobile){
          track.scrollBy({ left: dir * dist, behavior: 'smooth' });
        } else {
          var cards = Array.from(track.children);
          if(dir > 0){
            track.appendChild(cards[0]);
          } else {
            track.insertBefore(cards[cards.length - 1], cards[0]);
          }
        }
      }

      if(prev) prev.addEventListener('click', function(){ scrollByCard(-1); });
      if(next) next.addEventListener('click', function(){ scrollByCard(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function animateCounter(el) {
      if (el.dataset.animated === 'true') return;
      el.dataset.animated = 'true';

      var valueEl = el.querySelector('.ph-stat__value');
      if (!valueEl) return;

      var raw = (el.dataset.target || '').toString().trim();
      var duration = parseInt(el.dataset.duration, 10) || 2000;

      // Detect "k" multiplier and decimals
      var hasK = /k/i.test(raw);
      var numericPart = raw.replace(/[^0-9.]/g, '');
      var target = parseFloat(numericPart);

      if (isNaN(target)) {
        valueEl.textContent = raw;
        return;
      }

      var isDecimal = numericPart.indexOf('.') !== -1;
      var decimals = isDecimal ? (numericPart.split('.')[1] || '').length : 0;

      // Respect reduced-motion preference
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced) {
        valueEl.textContent = formatValue(target, decimals, hasK);
        return;
      }

      var start = null;
      var startValue = 0;

      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function formatValue(val, decimals, hasK) {
        if (hasK) {
          // Format like "28k"
          return Math.round(val).toString() + 'k';
        }
        if (decimals > 0) {
          return val.toFixed(decimals);
        }
        return Math.round(val).toString();
      }

      function step(timestamp) {
        if (!start) start = timestamp;
        var elapsed = timestamp - start;
        var progress = Math.min(elapsed / duration, 1);
        var eased = easeOutCubic(progress);
        var current = startValue + (target - startValue) * eased;

        valueEl.textContent = formatValue(current, decimals, hasK);

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          valueEl.textContent = formatValue(target, decimals, hasK);
        }
      }

      window.requestAnimationFrame(step);
    }

    function init(root) {
      var stats = root.querySelectorAll('[data-stat]');
      if (!stats.length) return;

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateCounter(entry.target);
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.35 });

        stats.forEach(function (s) { io.observe(s); });
      } else {
        // Fallback: animate immediately
        stats.forEach(animateCounter);
      }
    }

    function boot() {
      document.querySelectorAll('.ph-section').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    // Shopify theme editor support
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.ph-section');
      if (section) init(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
